import React, {useEffect, useRef, useState} from 'react';
import {List, ListItem} from "@chatui/core";
import './InputComposer.css';

function InputComposer(props) {


    if (props.active) {

        return (
            <List className={"input-composer-list"}>
                {
                    props.composers.map((item, index) => (
                        <ListItem
                            key={index}
                            rightIcon={item.icon}
                            onClick={item.onClick}
                        >
                            <p className={"composer-label"}>{item.label}</p>
                            <p className={"composer-description"}>{item.desc}</p>
                        </ListItem>
                    ))
                }
            </List>
        );
    }


    else return(<></>)
}

export default InputComposer;